// extracted by mini-css-extract-plugin
module.exports = {"HeaderElementLogo":"HeaderElementLogo_HeaderElementLogo__tUPC5","logoLink":"HeaderElementLogo_logoLink__1fw6s","logoElement":"HeaderElementLogo_logoElement__3A8t3"};